import sdl from '@jds/react-generated-sdl/SwadeshFullWidthMedia';
import type { SwadeshFullWidthMediaProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: SwadeshFullWidthMediaProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    showPlayButton = false,
    contentAlignment = 'top-left',
    overlay = false,
    ratio = '100',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { showPlayButton, contentAlignment, overlay, ratio, ...rest },
    'SwadeshFullWidthMedia',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const SwadeshFullWidthMedia = withLogic(
  Component
) as React.FC<SwadeshFullWidthMediaProps> & { slotName?: string };

SwadeshFullWidthMedia.displayName = 'SwadeshFullWidthMedia';
SwadeshFullWidthMedia.slotName = 'swadesh_full_width_media';

export { SwadeshFullWidthMedia, type SwadeshFullWidthMediaProps };
